import React from 'react';
import { Box, Typography } from '@mui/material';
import { useParams } from 'react-router-dom';

const PositionDetails: React.FC = () => {
  const { id } = useParams();

  return (
    <Box>
      <Typography variant="h4">
        Position Details - {id}
      </Typography>
      <Typography variant="body1" color="text.secondary" sx={{ mt: 2 }}>
        Position details page coming soon...
      </Typography>
    </Box>
  );
};

export default PositionDetails;